import { StreamType } from './types';
import { BaseStream } from './base/types';

export const reduxKey = '@@streams';
export const actionKey = 'STREAM';
export const defaultStreamState: BaseStream = {
  streamId: '',
  streamType: StreamType.WITH_CURSOR,
  items: [],
  itemsPerFetch: 0,
  hasMore: false,
  hasLess: false,
};
